import angular from 'angular';
import { AuthInterceptor } from './auth/auth.interceptor';
import { AuthService } from './auth/auth.service';
import { PrincipalService } from './auth/principal.service';
import { AuthServerProvider } from './auth/provider/auth.session.service';
import { CorreiosResource } from './correios/correios.resource';
import { CorreiosService } from './correios/correios.service';
import { HistoricoService } from './historico/historico.service';
import { NfeService } from './nfe/nfe.service';
import { PedidoResource } from './pedido/pedido.resource';
import { PedidoService } from './pedido/pedido.service';
import { PerfilResource } from './perfil/perfil.resource';
import { PerfilService } from './perfil/perfil.service';
import { RastreamentoResourceFactory } from './rastreamento/rastreamento.resource';
import { RastreamentoService } from './rastreamento/rastreamento.service';

export const ServicesModule = 'mandae.services';

angular.module(ServicesModule, [
  'ngResource',
  'LocalStorageModule',
])
.service('authInterceptor', AuthInterceptor)
.service('AuthServerProvider', AuthServerProvider)
.service('Auth', AuthService)

.service('NfeService', NfeService)
.service('Principal', PrincipalService)

// Historico
.service('Historico', HistoricoService)

// Correios (reversa v2)
.factory('CorreiosResource', CorreiosResource)
.service('Correios', CorreiosService)

// Pedido
.factory('PedidoResource', PedidoResource)
.service('Pedido', PedidoService)

// Perfil
.factory('PerfilResource', PerfilResource)
.service('Perfil', PerfilService)

// Rastreamento
.factory('RastreamentoResource', RastreamentoResourceFactory)
.service('Rastreamento', RastreamentoService)